import { Link } from "@tanstack/react-router";
import { ChefHat } from "lucide-react";

export function SiteFooter() {
  return (
    <footer className="border-t border-border/60 bg-secondary/40">
      <div className="container mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div className="grid gap-12 md:grid-cols-5">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="grid h-9 w-9 place-items-center rounded-full bg-gold">
                <ChefHat className="h-4 w-4" />
              </span>
              <span className="font-display text-xl">
                Chef<span className="text-gold">&nbsp;Connect</span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-muted-foreground">
              Il punto di riferimento in Italia per trovare chef privati, personal chef e cuochi a domicilio.
            </p>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold tracking-wide uppercase">Piattaforma</h4>
            <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
              <li><Link to="/search" className="hover:text-foreground">Cerca chef</Link></li>
              <li><Link to="/mappa" className="hover:text-foreground">Mappa chef</Link></li>
              <li><Link to="/come-funziona" className="hover:text-foreground">Come funziona</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold tracking-wide uppercase">Per gli chef</h4>
            <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
              <li><Link to="/diventa-chef" className="hover:text-foreground">Diventa Chef</Link></li>
              <li><Link to="/premium" className="hover:text-foreground">Premium</Link></li>
              <li><Link to="/come-funziona" className="hover:text-foreground">Serve la Partita IVA?</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold tracking-wide uppercase">Azienda</h4>
            <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
              <li><Link to="/chi-siamo" className="hover:text-foreground">Chi siamo</Link></li>
              <li><Link to="/contatti" className="hover:text-foreground">Contatti</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold tracking-wide uppercase">Legale</h4>
            <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
              <li><Link to="/termini" className="hover:text-foreground">Termini</Link></li>
              <li><Link to="/privacy" className="hover:text-foreground">Privacy</Link></li>
              <li><Link to="/cookie" className="hover:text-foreground">Cookie</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-border/60 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} ChefConnect. Tutti i diritti riservati.
          </p>
        </div>
      </div>
    </footer>
  );
}